<template>
    <div class="not-found-page">
        <div class="bg-gray-50 font-medium border-gray-200 border-b">
            <div class="p-5 mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">
                <p class="font-medium mb-2">
                    The link you are trying to access does not exist or has expired.
                </p>
                <p class="font-medium">
                    Should you have any questions or require additional assistance please do not hesitate to give us a call at <a :href="`tel:${data.consumerPortalNumber}`" :class="`font-semibold text-${$root.theme}-500`">{{ data.consumerPortalNumber }}.</a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['data']
    }
</script>
